import { useState, useEffect } from 'react';
import { db } from '@healthdesk/shared-services';
import { DDX_AI_FINDING_SEVERITY_ORDER, DDX_AI_REVIEW_FIELD_SORT_ORDER } from '@healthdesk/shared-utils';

/**
 * @param {{ severity?: string, stableKey?: string, fieldKey?: string }} a
 * @param {{ severity?: string, stableKey?: string, fieldKey?: string }} b
 */
function compareFindings(a, b) {
  const sevIdx = (s) => {
    const i = DDX_AI_FINDING_SEVERITY_ORDER.indexOf(s);
    return i >= 0 ? i : 99;
  };
  const fieldIdx = (f) => {
    const i = DDX_AI_REVIEW_FIELD_SORT_ORDER.indexOf(f);
    return i >= 0 ? i : 99;
  };
  const c = sevIdx(a.severity) - sevIdx(b.severity);
  if (c !== 0) return c;
  const d = String(a.stableKey || '').localeCompare(String(b.stableKey || ''));
  if (d !== 0) return d;
  return fieldIdx(a.fieldKey) - fieldIdx(b.fieldKey);
}

/**
 * @param {string | null | undefined} jobId
 */
export function useDdxAiFindings(jobId) {
  const [findings, setFindings] = useState([]);
  const [loading, setLoading] = useState(!!jobId);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!jobId) {
      setFindings([]);
      setLoading(false);
      return undefined;
    }
    setLoading(true);
    const q = db.collectionGroup('aiFindings').where('jobId', '==', jobId);
    const unsub = q.onSnapshot(
      (snap) => {
        const list = snap.docs.map((d) => {
          const parent = d.ref.parent && d.ref.parent.parent;
          const stagedRowDocId = parent ? parent.id : '';
          return { id: d.id, stagedRowDocId, ...d.data() };
        });
        list.sort(compareFindings);
        setFindings(list);
        setLoading(false);
        setError(null);
      },
      (err) => {
        setError(err);
        setLoading(false);
      },
    );
    return () => unsub();
  }, [jobId]);

  return { findings, loading, error };
}
